var rif = $('#RicercaUtente2');
var dropdown = $('#DropDownUtenti');

var cc = function(vars) {
  console.log(vars);
};

rif.click(function () {
    dropdown.show();
    var popper = new Popper(rif, dropdown, {
        placement: 'top'
    });
});

/**
 * - - - - - - - - - - - - - - - - - - - -
 * POP HOVER E TOOLTIP
 * - - - - - - - - - - - - - - - - - - - -
 */

$(function () {
    $('[data-toggle="tooltip"]').tooltip()

    $('[data-toggle="popover"]').popover();

    //Popovers tippy

    //
    if (document.getElementById('tt-temp-prezzispeciali')) {
        tippy('.special-price-btn', {
            content: document.getElementById('tt-temp-prezzispeciali').innerHTML,
            allowHTML: true,
            interactive: true,
            theme: 'light-border',
        });
        tippy('.centro-ibp', {
            content: document.getElementById('tt-ibp-map').innerHTML,
            allowHTML: true,
            interactive: true,
            theme: 'light-border',
        });
    }
    tippy('[data-tippy-content]',{
        allowHTML: true,
        interactive: true,
        theme: 'light-border',
        appendTo: () => document.body ,
    });

    // Popovers bootstrap
    $("[data-toggle=popover]").each(function (i, obj) {

        $(this).popover({
            html: true,
            content: function () {
                var id = $(this).attr('id')
                return $('#popover-content-' + id).html();
            }
        });
    });

    // $(".hover-close-ibp-pop").popover({
    //     trigger: "manual",
    //     html: true,
    //     template: '<div class="popover popover-ibp closable " role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><button type="button" id="close" class="close" onclick="$(&quot;.hover-close-ibp-pop&quot;).popover(&quot;hide&quot;);">&times;</button></<div><div class="popover-body"></div></div>'
    // })
    //     .on("mouseenter", function () {
    //         var _this = this;
    //         $(this).popover("show");
    //         $(".popover").on("mouseleave", function () {
    //             $(_this).popover('hide');
    //         });
    //     }).on("mouseleave", function () {
    //     var _this = this;
    //     setTimeout(function () {
    //         if (!$(".popover:hover").length) {
    //             $(_this).popover("hide");
    //         }
    //     }, 2000);
    // });


    // $(".hover-close-pop").popover({
    //     trigger: "manual",
    //     html: true,
    //     template: '<div class="popover closable" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><button type="button" id="close" class="close" onclick="$(&quot;.hover-close-pop&quot;).popover(&quot;hide&quot;);">&times;</button></<div><div class="popover-body"></div></div>'
    // })
    //     .on("mouseenter", function () {
    //         var _this = this;
    //         $(this).popover("show");
    //         $(".popover").on("mouseleave", function () {
    //             $(_this).popover('hide');
    //         });
    //     }).on("mouseleave", function () {
    //     var _this = this;
    //     setTimeout(function () {
    //         if (!$(".popover:hover").length) {
    //             $(_this).popover("hide");
    //         }
    //     }, 2000);
    // });

    // $(".hover-pop").popover({
    //     trigger: "manual",
    //     html: true,
    // })
    //     .on("mouseenter", function () {
    //         var _this = this;
    //         $(this).popover("show");
    //         $(".popover").on("mouseleave", function () {
    //             $(_this).popover('hide');
    //         });
    //     }).on("mouseleave", function () {
    //     var _this = this;
    //     setTimeout(function () {
    //         if (!$(".popover:hover").length) {
    //             $(_this).popover("hide");
    //         }
    //     }, 500);
    // });

});

$('#myModal').on('shown.bs.modal', function () {
    $('#myInput').trigger('focus')
});


// disattivare Hover per mobile

function watchForHover() {
    var hasHoverClass = false;
    var container = document.body;
    var lastTouchTime = 0;

    function enableHover() {
        // filter emulated events coming from touch events
        if (new Date() - lastTouchTime < 500) return;
        if (hasHoverClass) return;

        container.className += ' hasHover';
        hasHoverClass = true;
    }

    function disableHover() {
        if (!hasHoverClass) return;

        container.className = container.className.replace('hasHover', '');
        hasHoverClass = false;
    }

    function updateLastTouchTime() {
        lastTouchTime = new Date();
    }

    document.addEventListener('touchstart', updateLastTouchTime, true);
    document.addEventListener('touchstart', disableHover, true);
    document.addEventListener('mousemove', enableHover, true);

    enableHover();
}

watchForHover();


// Per image Blur nella pagina corso

$(function () {
    function render() {
        if ($('.image-blur').length) {
            var content = $('#main-content-det');
            var container = $('#course-image-height');

            var contentTop = content.offset().top;
            var containerTop = container.offset().top;

            $('.image-blur').removeAttr('style').css({
                width: container.width(),
                height: container.height(),
                marginLeft: -content.offset().left - 16,//padding del box in cui è contenuto
                marginTop: -contentTop + containerTop,
                marginBottom: -container.height() + contentTop - containerTop,
            });
        }
        if ($('.image-blur-side').length) {
            var content = $('#blur-side-menu');
            var container = $('#course-image-height');

            var contentTop = content.offset().top;
            var containerTop = container.offset().top;

            $('.image-blur-side').removeAttr('style').css({
                width: container.width(),
                height: container.height(),
                marginLeft: -content.offset().left - 0,//padding del box in cui è contenuto
                marginTop: -contentTop + containerTop,
                marginBottom: -container.height() + contentTop - containerTop,
            });
        }
    }

    render();
    // When the window resizes, or the `.box` moves/resizes, recall the `render` function.
    $(window).resize(render);
});

// Forms select display elementi nascosti
// --------------------------------------

// Select Lavoro

function CheckJobs(val) {
    //console.log(val);
    // from .env
    // GLOBAL_USER_OCCUPATION_MEDICAL_ID=3
    // GLOBAL_USER_OCCUPATION_OTHER_ID=4
    var GLOBAL_USER_OCCUPATION_MEDICAL_ID=3;
    var GLOBAL_USER_OCCUPATION_OTHER_ID=4;
    if (val && val == GLOBAL_USER_OCCUPATION_MEDICAL_ID) {
        $('#docspec').show();
        $('#occupation_other').hide();
        $('#mydisplay_occupation_medical_type').show();
        $('#mydisplay_occupation_other').hide();
    } else if (val == GLOBAL_USER_OCCUPATION_OTHER_ID) {
        $('#docspec').hide();
        $('#occupation_other').show();
        $('#mydisplay_occupation_medical_type').hide();
        $('#mydisplay_occupation_other').show();
    } else {
        $('#docspec').hide();
        $('#occupation_other').hide();
        $('#mydisplay_occupation_medical_type').hide();
        $('#mydisplay_occupation_other').hide();
    }
};

// Select Form indirizzo
function CheckCountry(val) {
    if (val && val.toLowerCase() == 'it') {
        $("#provselect").show();
        //$("#cfgroup").show();
        $("#states").hide();
        $("#mydisplay_province").show();
        $("#mydisplay_state").hide();
        $("#mydisplay_cf").show();

        //document.getElementById('provselect').style.display = 'block';
        //document.getElementById('cfgroup').style.display = 'block';
        //document.getElementById('states').style.display = 'none';
    } else {
        $("#provselect").hide();
        //$("#cfgroup").hide();
        $("#states").show();
        //document.getElementById('provselect').style.display = 'none';
        //document.getElementById('cfgroup').style.display = 'none';
        //document.getElementById('states').style.display = 'block';
        $("#mydisplay_province").hide();
        $("#mydisplay_state").show();
        $("#mydisplay_cf").hide();
    }
};

// Select Form indirizzo Fatturazione
function CheckCountryPri(val) {
    if (val && val.toUpperCase() == 'IT') {
        //$("#pri-cfgroup").show();
        $("#pri-provselect").show();
        $("#myaccount_mydata_invoice_address_pri-invoice_province").parent("div.form-group").show();
        $("#pri-states").hide();
    } else {
        //$("#pri-cfgroup").hide();
        $("#pri-provselect").hide();
        $("#myaccount_mydata_invoice_address_pri-invoice_province").parent("div.form-group").hide();
        $("#pri-states").show();
    }
};

function CheckCountryCom(val) {
    if (val && val.toUpperCase() == 'IT') {
        $("#pivagroup").show();
        $("#sdigroup").show();
        $("#vatgroup").hide();
        $("#com-cfgroup").show();
        $("#com-provselect").show();
        $("#myaccount_mydata_invoice_address_com-invoice_province").parent("div.form-group").show();
        $("#com-states").hide();
    } else {
        $("#pivagroup").hide();
        $("#sdigroup").hide();
        $("#vatgroup").show();
        $("#com-cfgroup").hide();
        $("#com-provselect").hide();
        $("#myaccount_mydata_invoice_address_com-invoice_province").parent("div.form-group").hide();
        $("#com-states").show();
    }
};




// Modifica Dati Fatturazione
// $('#modbillingbtn').click(function () {
//     document.getElementById('modbilling').style.display = 'none',
//         document.getElementById('modbillingform').style.display = 'block';
// });
// Modifica Dati Fatturazione
$("input[name='use_invoice_address']").change(function(){
    if ($(this).val()==1) {
        $('#modbillingform').show();
    } else {
        $('#modbillingform').hide();
    }
});



function CheckBillSubj(val) {
    if (val && val == 'private')
        document.getElementById('privbillform').style.display = 'block',
            document.getElementById('compbillform').style.display = 'none';
    else
        document.getElementById('privbillform').style.display = 'none',
            document.getElementById('compbillform').style.display = 'block';
};
/**
 * - - - - - - - - - - - - - - - - - - - -
 * SELETTORE DATE CORSI MOBILE
 * - - - - - - - - - - - - - - - - - - - -
 */
$( ".course-dates-selection .active" ).click(function( event ) {
    event.preventDefault();
    $( ".course-dates-selection .nav-link" )
      .toggleClass( "open");
});

// Calendario
// --------------------------------------

// Hover corsi su più mesi
$("#calendar").find(".split").parent().hover(
    function () {
        var dateId = this.dataset.courseDateId;
        $("a[data-course-date-id='" + dateId + "']").toggleClass("active");
    },
);

// Menu laterale corsi su mobile
// --------------------------------------

$("#collapseSide").click(function () {
    $(".sidebar").addClass("transition");
    $(".sidebar").toggleClass("open");
    $(this).toggleClass("open");
});

// --------------------------------------
// Pagina Admin
// --------------------------------------

$('#searchswitch').click(function(){
    $('#list_search_detail').toggle(500);
    $('#list_search_free').toggle(500);
})

// --------------------------------------
// Tabella Admin
// --------------------------------------

$(function() {

    //var $fixedRow = $table.clone().insertBefore($table).addClass('fixed-row').removeAttr('id');
    //var $fixedColumn = $table.clone().insertAfter($table).addClass('fixed-column').removeAttr('id').removeClass('table-hover');

    // creazione della fixed colum e fixed row
    //$fixedColumn.find('th:not(:last-child),td:not(:last-child)').remove();
    //$fixedRow.find('tbody').remove();

    var $table = $('#main-table');
    var $fixedRow = $('.fixed-row');
    var $fixedColumn = $('.fixed-column');

   
    // calcola dimensioni tabella
    function calc() {

        // Posiziono in maniera corretta la tabella
        $('.table-container').css({ 'padding-right' : $fixedColumn.outerWidth()/* , 'padding-top' : $fixedRow.outerHeight() */ });
        $fixedColumn.css('top',  $fixedRow.height());


        $fixedColumn.find('tbody').find('tr').each(function (i, elem) {
            $(this).height($table.find('tbody').find('tr').eq(i).height());
            $table.find('tbody').find('tr').eq(i).height($(this).height());
        });

        var mainRows = $table.find('thead').find('th');
    
        // dimensioni singole celle della fixed row
        for (var i = 0; i < mainRows.length; i++) {
            $fixedRow.find('th').eq(i).width(
                mainRows.eq(i).width()
            );
        };
        $fixedRow.width($table.width());
        
        // dimensioni box operazioni
        $('.operation').outerHeight(
            $fixedRow.outerHeight()
        ).outerWidth(
            $fixedColumn.outerWidth()   
        )    
    
    }
    


    // $(document).on('mousemove', calc);
    $(window).resize(calc);

    // rimuovo colonne e righe che non servono
    //$table.find('tr').find('td:last-child').remove();
    // $table.find('thead').remove();
    // $table.addClass('table-fixed');
    // $fixedColumn.find('thead').remove();

    calc();

    // scroll the fixed column and row
    $('.main-table-wrap').scroll(function () {
        var rc = $(this).closest('.table-container');
        var colW = rc.find('.fixed-column');
        var rowW = rc.find('.fixed-row');
        
        colW.css('top',  $fixedRow.height() + ($(this).scrollTop()*-1));
        rowW.css('left', ($(this).scrollLeft()*-1));        
    });


});

        
// $('.SBWrapper').scroll(function () {
//     var rc = $(this).closest('.relativeContainer');
//     var lfW = rc.find('.leftSBWrapper');
//     var tpW = rc.find('.topSBWrapper');
    
//     lfW.css('top', ($(this).scrollTop()*-1));
//     tpW.css('left', ($(this).scrollLeft()*-1));        
// });

// $(window).resize(function () {
//     $('.rightContainer').width(function () {
//         return $(this).closest('.relativeContainer').outerWidth() - $(this).siblings('.leftContainer').outerWidth();
//     });
                               
// });




/*
*********************
****** Claudio ******
*********************
*/
$(function () {
    // open generic modal confirm with specific title and content
    window.openModalConfirm = function (title = '', content = '', timeoutSeconds = 0) {
        if (title) {
            $("#modal-confirm .modal-confirm-confirmtitle").html(title);
        }
        if (content) {
            $("#modal-confirm .modal-confirm-confirmcontent").html(content);
        }
        $("#modal-confirm").modal('show');
        if (timeoutSeconds) {
            setTimeout(function () {
                $("#modal-confirm").modal('hide');
            }, timeoutSeconds * 1000);
        }
    };

    // open generic modal error with specific title and content
    window.openModalError = function (title = '', content = '', timeoutSeconds = 0) {
        if (title) {
            $("#modal-error .modal-error-errortitle").html(title);
        }
        if (content) {
            $("#modal-error .modal-error-errorcontent").html(content);
        }
        $("#modal-error").modal('show');
        if (timeoutSeconds) {
            setTimeout(function () {
                $("#modal-error").modal('hide');
            }, timeoutSeconds * 1000);
        }
    };



    // reset generic modal confirm when hidden
    $('#modal-confirm').on('hidden.bs.modal', function (e) {
        $("#modal-confirm .modal-confirm-confirmtitle").html('');
        $("#modal-confirm .modal-confirm-confirmcontent").html('');
    });
    // reset generic modal error when hidden
    $('#modal-error').on('hidden.bs.modal', function (e) {
        $("#modal-error .modal-error-errortitle").html('');
        $("#modal-error .modal-error-errorcontent").html('');
    });
    //
    $('#edit-email').on('hidden.bs.modal', function (e) {
        $("#newEmail").val('');
        $("#verifyNewEmail").val('').removeClass('is-invalid');
    });
    $("#edit-email .save-button").click(function (e) {
        var email1 = $("#newEmail");
        var email2 = $("#verifyNewEmail");
        if (email1.val().trim().length > 0 && email1.val().trim() == email2.val().trim()) {
            email2.removeClass('is-invalid');
            var payload = {
                "cmd": "update_email",
                "new_email": email1.val().trim(),
            };
            $.post('/myaccount/action', payload).done(function (data) {
                if (!data.hasOwnProperty('error')) {
                    data.error = 'Per favore riprova più tardi.';
                }
                if (data.error === false) {
                    openModalConfirm('Grazie', "Ti è stato mandato un link all'email " + payload.new_email);
                } else {
                    openModalError('Errore', data.error);
                }
            }).fail(function () {
                openModalError('Errore', 'Per favore riprova più tardi.');
            }).always(function () {
                $('#edit-email').modal('hide');
            });
        } else {
            email2.addClass('is-invalid');
            email2.focus();
        }
    });



    $('#edit-password').on('hidden.bs.modal', function (e) {
        $("#old-password").val('');
        $("#new-password").val('');
        $("#verify-new-password").val('').removeClass('is-invalid');
    });
    $("#edit-password .save-button").click(function (e) {
        var old = $("#old-password");
        var pass1 = $("#new-password");
        var pass2 = $("#verify-new-password");
        if (pass1.val().trim().length > 0 && pass1.val().trim() == pass2.val().trim()) {
            pass2.removeClass('is-invalid');
            var payload = {
                "cmd": "update_password",
                "old_pass": old.val().trim(),
                "new_pass": pass1.val().trim(),
            };
            $.post('/myaccount/action', payload).done(function (data) {
                if (!data.hasOwnProperty('error')) {
                    data.error = 'Per favore riprova più tardi.';
                }
                if (data.error === false) {
                    openModalConfirm('Grazie', "Password cambiata con successo.");
                } else {
                    openModalError('Errore', data.error);
                }
            }).fail(function () {
                openModalError('Errore', 'Per favore riprova più tardi.');
            }).always(function () {
                $('#edit-password').modal('hide');
            });
        } else {
            pass2.addClass('is-invalid');
            pass2.focus();
        }
    });

    // see #update_user_field
    var editUserFields = [
        'cf',
        'phone',
        'mobile',
        'occupationOther',
    ];
    editUserFields.forEach(field => {
        $("#edit-"+field+" .btn-primary").click(function (e) {
            var payload = {
                "cmd": "update_user_field",
                "field": field,
                "value": $("#edit-"+field+"-value").val().trim(),
            };
            $.post('/myaccount/action', payload).done(function (data) {
                if (!data.hasOwnProperty('error')) {
                    data = {"error":"Per favore riprova più tardi."};
                }
                if (data.error === false) {
                    $("#span-edit-"+field).html(data.value);
                    openModalConfirm('Grazie', "Dati salvati.");
                } else {
                    var error_string = (data.error === true) ? '' : data.error;
                    openModalError('Errore', error_string);
                }
            }).fail(function () {
                openModalConfirm('Errore', 'Per favore riprova più tardi.');
            }).always(function () {
                $("#edit-"+field).modal('hide');
            });
        });
    });

    $("#user_data_cart_form_country").on("change",function(e){
        CheckCountry($(this).val())
    });
    $("#myaccount_mydata_address_country").on("change",function(e){
        CheckCountry($(this).val())
    });
    $("#myaccount_mydata_invoice_address_invoice_country").on("change",function(e){
        CheckCountry($(this).val())
    });

    $("#user_data_cart_form_occupation_id").on("change",function(e){
        CheckJobs($(this).val())
    });

    $("#js_persdata_html_twig").click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('form[name="user_data_cart_form"]').submit();
    });
    $("#js_payoptions_html_twig").click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("#form_paymethods_html_twig").submit();
    });
    $("#js_payrecap_html_twig").click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("#form_payrecap_html_twig").submit();
    });

    if ($('#myaccount_mydata_address_country').length) {
        // run CheckCountry when page is loaded
        CheckCountry($("#myaccount_mydata_address_country").val());
    } else if ($('#myaccount_mydata_invoice_address_invoice_country').length) {
        // run CheckCountry when page is loaded
        CheckCountry($("#myaccount_mydata_invoice_address_invoice_country").val());
    } else {
        // run CheckCountry when page is loaded
        CheckCountry($("#user_data_cart_form_country").val());
    }



    // run CheckJobs when page is loaded
    CheckJobs($("#user_data_cart_form_occupation_id").val());

    $(document).on("change",
        "#myaccount_mypaymentsmethods input[name='paymentRadio']",
        function(e){
            e.preventDefault();
            e.stopPropagation();

            //console.log($(this).val());
            var payload = {
                "cmd": "update_user_default_payment_method",
                "default_payment_method": $(this).val()
            };
            $.post('/myaccount/action', payload).done(function (data) {
                if (!data.hasOwnProperty('error')) {
                    data.error = 'Per favore riprova più tardi.';
                }
                if (data.error === false) {
                    $("#myaccount_mypaymentsmethods").html(data.html_form);
                    $("div.flash_default_payment_method").delay(3000).fadeOut('slow');
                } else {
                    openModalConfirm('Errore', data.error);
                }
            }).fail(function () {
                openModalConfirm('Errore', 'Per favore riprova più tardi.');
            }).always(function () {

            });
        });

    $("div.flash_mynewsletter").delay(3000).fadeOut('slow');

    // https://api.jqueryui.com/datepicker, search "Localization"
    //$.datepicker.setDefaults( $.datepicker.regional[ "it" ] );
    $( ".invoice-js-datepicker" ).datepicker({
        altField: "#invoice_alt_field",
        altFormat: "yy-mm-dd",
        dateFormat: "dd/mm/yy"
    });

    $( ".search_detail_js_datepicker" ).each(function(){
        var that = $( this );
        that.datepicker({
            altField: that.prev('input[type=hidden]'),
            altFormat: "yy-mm-dd",
            dateFormat: "dd/mm/yy"
        });
    });




    $(".js-button-edit-address").click(function(){
        if ($(".js-div-edit-address").is(':visible')) {
            $(".js-button-edit-address").html('Modifica');
            $(".js-div-edit-address").hide();
        } else {
            $(".js-button-edit-address").html('Chiudi');
            $(".js-div-edit-address").show();
        }
    });

    // $(document).on("submit","#myaccount_mydata_address", function(e){
    //     e.preventDefault();
    //     e.stopPropagation();
    //     $.post('server.php', $('#myaccount_mydata_address').serialize(), function(data){
    //
    //     });
    // })

    var courseSelect = $(".js-user_add_registration_course_date");
    var courseDateTarget = $(".js-user_add_registration_course_date-target");
    courseSelect.on("change", function(e){
        $.ajax({
            url: courseSelect.data('course-date-id-url'),
            data: {
                course_date_id: courseSelect.val()
            },
            success: function (html) {
                console.log(html);
                if (!html) {
                    courseDateTarget.find('select').remove();
                    courseDateTarget.addClass('d-none');
                    return;
                }

                courseDateTarget.html(html).removeClass('d-none');
            }
        });
    });

    $("button.btn-add-registration-with-email").click(function(e){
        var myform = $(this).closest("form");
        myform.find('[name="with-email"]').val("yes");
        myform.submit();
    });

    $("button.btn-add-registration-no-email").click(function(e){
        var myform = $(this).closest("form");
        myform.find('[name="with-email"]').val("no");
        myform.submit();
    });

    $("button.btn-add-invoice-with-email").click(function(e){
        var myform = $(this).closest("form");
        myform.find('[name="with-email"]').val("yes");
        myform.submit();
    });
    $("button.btn-add-invoice-no-email").click(function(e){
        var myform = $(this).closest("form");
        myform.find('[name="with-email"]').val("no");
        myform.submit();
    });


    //CheckCountryPri($("#myaccount_mydata_invoice_address_pri-invoice_country").val());
    //CheckCountryCom($("#myaccount_mydata_invoice_address_com-invoice_country").val());
    $("#myaccount_mydata_invoice_address_pri-invoice_country").change(function(e){
        e.preventDefault();
        e.stopPropagation();
        CheckCountryPri($(this).val());
    });
    $("#myaccount_mydata_invoice_address_com-invoice_country").change(function(e){
        e.preventDefault();
        e.stopPropagation();
        CheckCountryCom($(this).val());
    });

    var update_use_invoice_address = function(e){
        e.preventDefault();
        e.stopPropagation();

        //console.log($(this).val());
        var payload = {
            "cmd": "toggle_use_invoice_address"
        };
        $.post('/myaccount/action', payload).done(function (data) {
            if (!data.hasOwnProperty('error')) {
                data.error = 'Per favore riprova più tardi.';
            }
            if (data.error === false) {
                $("input.flash_use_invoice_address0").prop('checked', false);
                $("input.flash_use_invoice_address1").prop('checked', false);
                $("input.flash_use_invoice_address"+data.use_invoice_address_int).prop('checked', true);

                $("div.flash_use_invoice_address").show().delay(1500).fadeOut('slow');
            } else {
                openModalConfirm('Errore', data.error);
            }
        }).fail(function () {
            openModalConfirm('Errore', 'Per favore riprova più tardi.');
        }).always(function () {

        });
    };

    $("#bill-addres-1").change(update_use_invoice_address);
    $("#bill-addres-2").change(update_use_invoice_address);

    $("button.js-registration-approved-to-attended").click(function(e){
        e.preventDefault();
        e.stopPropagation();
        $(this).closest("form").find("select.registration_status").each(function(){
            // ($(this).val() == 'approved' || $(this).val() == 'ordered') {
            if ($(this).val() == 'approved') {
                $(this).val('attended');
            }
        });
    });

    $("button.js-registration-open-to-expired").click(function(e){
        e.preventDefault();
        e.stopPropagation();
        $(this).closest("form").find("select.registration_status").each(function(){
            // if ($(this).val() == 'cart' || $(this).val() == 'open' || $(this).val() == 'waitinglist') {
            if ($(this).val() == 'cart' || $(this).val() == 'open') {
                $(this).val('expired');
            }
        });
    });

    $("#from_user_to_registration_form_courseDateId, .from_user_to_registration_form_courseDateId").change(function(e){
        e.preventDefault();
        e.stopPropagation();

        var user_id = $(this).closest('form').find("input[name='user_id']").val();
        var current_course_date_id = $(this).closest('form').find("input[name='registration[current_course_date_id]']").val();
        var $registrationDiscountTarget = $('.js-registration-discount-target');

        var $buttonMandaEmail = $(this).closest('form').find('.manda-email');
        if ($(this).val() == current_course_date_id) {
            $buttonMandaEmail.addClass('hidden');
            $buttonMandaEmail.prop('disabled', true);
        } else {
            $buttonMandaEmail.removeClass('hidden');
            $buttonMandaEmail.prop('disabled', false);
        }

        $.ajax({
            url: $(this).data('registration-discount-url'),
            data: {
                course_date_id: $(this).val(),
                user_id: user_id
            },
            success: function(html) {
                if (!html) {
                    $registrationDiscountTarget.find('select').remove();
                    $registrationDiscountTarget.addClass('d-none');

                    return;
                }

                // Replace the current field and show
                $registrationDiscountTarget
                    .html(html)
                    .removeClass('d-none')
            }
        });
        
        var payload = {
            "cmd": "from_user_to_registration_load_courseDate",
            "user_id": user_id,
            "course_date_id": $(this).val()
        };

        if (payload.user_id == "0" || payload.course_date_id == "0") {
            $("#add_registration_course_date_info").html('&nbsp;');
            return;
        }

        $("#add_registration_course_date_info").html('...');

        $.get('/myadmin/action', payload).done(function(data){
            var dateCourseInfo = '';
            if (data.hasOwnProperty('error') && data.error === false) {
                var iscritti = parseInt(data.courseDateReport['Iscritti']);
                var seats_max = parseInt(data.courseDateReport['seats_max']);
                dateCourseInfo += 'Iscritti: '+iscritti+'/'+data.courseDateReport['Capacità'];
                dateCourseInfo += ' (Limite MAX: '+seats_max+')';
                if (iscritti < seats_max) {
                    dateCourseInfo += ' - Posti rimanenti: '+(seats_max - iscritti);
                } else {
                    dateCourseInfo += ' - Corso pieno';
                }

                var discount_report = data.courseDateReport['discount_report'];
                if (discount_report.length) {
                    dateCourseInfo += '<p><strong>Sconti attivi:</strong><br>' + discount_report + '</p>';
                }

                if (data.hasOwnProperty('user_discount_data')
                    && data.user_discount_data
                    && data.user_discount_data.hasOwnProperty('id')
                    && data.user_discount_data.name
                ) {
                    dateCourseInfo += '<p style="font-weight: bold">'
                                        +data.user_discount_data.user_fullname
                                        +' ha diritto allo sconto '
                                        +data.user_discount_data.name
                                        +'</p>';
                }
            }
            $("#add_registration_course_date_info").html(dateCourseInfo);
        }).fail(function () {
            $("#add_registration_course_date_info").html('Errore connessione...');
        });
    });

    // update after load
    $("#from_user_to_registration_form_courseDateId, .from_user_to_registration_form_courseDateId").trigger("change");

    // --------------------------------------
    // Modal Laboratori
    // --------------------------------------

    // funzione per nascondere opzioni 3 scelta
    var nascondi3scelta = function() {
        $('#choice-3.richiesta-laboratori').val('');
        $('#choice-3.richiesta-laboratori option').each(function(){
            if ($(this).val() != '' ) {
                $(this).hide()
            }
        });
        // mostra tutte le opzioni per la seconda scelta
        $('#choice-2.richiesta-laboratori option').show();
    };

    // nascondi 3 scelta (perche' prima bisogna scegliere la 2 scelta)
    nascondi3scelta();

    // muovi le opzioni da una select all'altra
    var alterna = function(thatVal, myid) {
        if (thatVal != '') {
            $(myid+'.richiesta-laboratori option').each(function(){
                if ($(this).val() == thatVal ) {
                    $(this).hide()
                } else {
                    $(this).show()
                }
            });
        } else {
            if (myid == '#choice-3') {
                nascondi3scelta();
            } else {
                $('#choice-2.richiesta-laboratori option').show();
            }
        }
    };
    $('#choice-2.richiesta-laboratori').change(function(){
        alterna($(this).val(), "#choice-3");
    });
    $('#choice-3.richiesta-laboratori').change(function(){
        alterna($(this).val(), "#choice-2");
    });

    $("#lab-req-btn").click(function(e){
        e.preventDefault();
        e.stopPropagation();
        $("#lab-req-form").submit();
    });

    $("#report_search_detail > form").submit(function(e) {

        e.preventDefault();

        var form = $(this);
        var url = form.attr('action');

        $.ajax({
            type: "GET",
            url: url,
            data: form.serialize(),
            success: function(data)
            {
                $("#reportdiv").html(data);
            }
        });

    });


}); // end claudio $(function(){
